import { render, staticRenderFns } from "./MemberContactInfoTable.vue?vue&type=template&id=3ae949e3&scoped=true&"
import script from "./MemberContactInfoTable.vue?vue&type=script&lang=js&"
export * from "./MemberContactInfoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae949e3",
  null
  
)

export default component.exports